export default __webpack_public_path__ + "static/applying-grid-dark-682ce46e2569130d548744469fd3945e.png";